import React, { createContext, useState, useEffect, useContext } from 'react';
import API from '../api/axios';
import socket, { updateSocketToken } from '../socket';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const handleDeactivation = (data) => {
            console.warn('[INSTITUTIONAL_ENFORCEMENT] Account deactivated by administration.');
            alert(data.message || 'Institutional access suspended. Please contact support.');
            logout();
            window.location.href = '/account-disabled';
        };

        socket.on('user_deactivated', handleDeactivation);
        return () => socket.off('user_deactivated', handleDeactivation);
    }, []);

    useEffect(() => {
        const checkUser = async () => {
            const token = localStorage.getItem('token');
            if (token) {
                try {
                    const res = await API.get('/auth/me');
                    setUser(res.data);
                } catch (err) {
                    localStorage.removeItem('token');
                    setUser(null);
                }
            }
            setLoading(false);
        };
        checkUser();
    }, []);

    const login = async (email, password) => {
        const res = await API.post('/auth/login', { email, password });
        localStorage.setItem('token', res.data.token);
        setUser(res.data.user);
        updateSocketToken(res.data.token);
        return res.data;
    };

    const register = async (userData) => {
        const res = await API.post('/auth/register', userData);
        return res.data;
    };

    const logout = () => {
        localStorage.removeItem('token');
        setUser(null);
        updateSocketToken(null);
    };

    const value = React.useMemo(() => ({
        user,
        setUser,
        login,
        register,
        logout,
        loading
    }), [user, loading]);

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
